import { LitElement, TemplateResult, nothing } from 'lit';
import { property } from 'lit/decorators.js';
import { html } from 'lit/html.js';
import { classMap } from 'lit/directives/class-map.js';

import { DxoStylesTextBanner } from './DxoStylesTextBanner';

export class DxoUiTextBanner extends LitElement {
  static styles = [DxoStylesTextBanner];

  @property({ type: String, attribute: 'id' }) id = '';

  @property({ type: String, attribute: 'background-color' }) backgroundColor =
    '';

  @property({ type: String, attribute: 'eyebrow' }) eyebrow = '';

  @property({ type: String, attribute: 'headline' }) headline = '';

  @property({ type: String, attribute: 'action-type' }) actionType = '';

  @property({ type: String, attribute: 'action-text' }) actionText = '';

  @property({ type: String, attribute: 'banner-action' }) bannerAction = '';

  @property({ type: String, attribute: 'button-style' }) buttonStyle = '';

  @property({
    type: Boolean,
    converter: value => value === 'true',
  })
  newTab = false;

  @property({ type: String }) subHeadlineSlotContent = '';

  constructor() {
    super();
    this.buttonStyle = 'button-gravity-primary';
    this.backgroundColor = 'white';
  }

  handleSlotchange(e: any) {
    const childNodes = e.target.assignedNodes({ flatten: true });
    this.subHeadlineSlotContent = childNodes.map((node: any) =>
      node.textContent ? node.textContent : ''
    );
  }

  /*
    Getters and setters
  */
  getId = () => this.id.replace(/\s+/, '').toLowerCase();

  getComponentName = () => 'dxo-ui-text-banner';

  getButtonTemplate = (): TemplateResult => html`
    <dxo-ui-button
      id="text-banner-button-${this.getId()}"
      style-variant=${this.buttonStyle}
      click=${this.bannerAction}
      text=${this.actionText}
    >
    </dxo-ui-button>
  `;

  getLinkTemplate = (): TemplateResult => html`
    <dxo-ui-link
      id="text-banner-link-${this.getId()}"
      value=${this.actionText}
      hrefLink=${this.bannerAction}
      newTab=${this.newTab}
    >
    </dxo-ui-link>
  `;

  render() {
    const headlineClasses: any = {
      'pad_top--no-brow': this.eyebrow.length === 0,
      'pad_top--with-brow': this.eyebrow.length > 0,
      'text-banner-headline-text': true,
    };

    const subHeadlineClasses: any = {
      'pad_bot--no-cta': this.actionType.length === 0,
    };

    const actionLinkClasses: any = {
      'pad_top--no-subheadline': this.subHeadlineSlotContent.length === 0,
      'pad_top--with-subheadline': this.subHeadlineSlotContent.length > 0,
      'text-banner-actions': true,
    };

    const actionTypeList: Array<String> = ['link', 'button'];

    return html`
      <div
        id="${this.getId()}"
        class="text-banner text-banner-background-${this.backgroundColor}"
      >
        <div class="text-banner-wrapper">
          <div class="text-banner-content">
            ${this.eyebrow.length
              ? html`
                  <div class="text-banner-eyebrow">
                    <p class="text-banner-eyebrow-text">${this.eyebrow}</p>
                  </div>
                `
              : nothing}

            <div class="text-banner-headline">
              <p class="${classMap(headlineClasses)}">${this.headline}</p>
            </div>
            <div
              class="${classMap(subHeadlineClasses)} text-banner-sub-headline"
            >
              <slot
                name="subheadline-slot"
                @slotchange=${this.handleSlotchange}
              ></slot>
            </div>

            ${this.actionType &&
            actionTypeList.some(action => action === this.actionType)
              ? html`<div class="${classMap(actionLinkClasses)}">
                  ${this.actionType === 'link'
                    ? this.getLinkTemplate()
                    : this.getButtonTemplate()}
                </div>`
              : nothing}
          </div>
        </div>
      </div>
    `;
  }
}
